export default __webpack_public_path__ + "static/media/logoKikiTransparent.cda90289.png";